<template>
  <header class="app-header" id="topbar">
    <b-container>
      <b-row align-h="between" v-if="!isLoading">
        <b-col sm="6">
          <div class="logo">
            <b-btn variant="flat" @click="gotoHome" class="float-left p-0">
              <logo class="logo-svg topbar-brand-icon"></logo>
            </b-btn>
            <h2>Admin Panel v{{appInfo.APP_VERSION}}</h2>
          </div>
        </b-col>
        <b-col sm="6">
          <div class="user-menu">
            <a id="exPopover4">
              <img class="prof-pic" :src="appInfo.profilePicURL">
            </a>
          </div>
          <div class="top-menu text-right">
            <ul class="list-inline">
              <li>
                <a v-b-tooltip.hover title="Switch to old panel" :href="appInfo.APP_URL_V2">
                  <switch-icon class="icon switch-icon"></switch-icon>
                </a>
              </li>
              <li>
                <a id="exPopover3" v-b-tooltip.hover title="IWP update centre">
                  <update-icon class="icon"></update-icon>
                  <span class="badge" v-if="updateInfo">1</span>
                </a>
              </li>
              <!-- <li>
                <a>
                  <bell-icon class="icon"></bell-icon>
                </a>
              </li> -->

              <li>
                <a @click="showSettings()">
                  <cog-icon class="icon-default cog-icon"></cog-icon>
                </a>
              </li>
            </ul>
          </div>
        </b-col>
        <b-popover target="exPopover3" class="updatepopover" placement="bottomleft" triggers="click" container="topbar" @updateNow="updateNow" @show="resetDefaults">
          <b-card class="updatecard">

            <div v-if="isUpdating">
              <iframe style="min-height: 340px;
    min-width: 100%;" :src="serverURL+'update.php?action=appUpdate&newVersion='+updateInfo.newVersion"></iframe>
            </div>

            <div v-else>
              <b-card-body class="version-wrapper">
                <div v-if="updateInfo">
                  <div class="version">
                    <div class="version-number">
                      {{updateInfo.newVersion}}
                    </div>
                    <div class="new-version-text">
                      New version available
                    </div>
                  </div>
                  <div class="mini-change-log" v-html="updateInfo.updateDetails[updateInfo.newVersion].breifDescr">

                  </div>
                  <div class="changelog-link-cont">
                    <a :href="updateInfo.updateDetails[updateInfo.newVersion].changeLogLink" target="_blank"> View change log</a>
                  </div>
                </div>
                <div v-else>
                  <p class="card-text">Your panel is up-to-date.</p>
                </div>
              </b-card-body>
              <b-card-footer>
                <b-button variant="outline-secondary" size="sm" @click="checkUpdate">Check Update
                  <spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner>
                </b-button>
                <b-button variant="primary" v-if="updateInfo" size="sm" @click="updateNow">Update Now</b-button>
              </b-card-footer>
            </div>
          </b-card>
        </b-popover>
        <b-popover target="exPopover4" class="logoutpopover" triggers="click blur" placement="bottomleft" container="topbar">
          <b-card>
            <ul>
              <li>
                <a :href="appInfo.APP_URL_V2+'login.php?logout=now'">Logout</a>
              </li>
            </ul>
          </b-card>
        </b-popover>
      </b-row>
    </b-container>
    <settings ref="settingsmodal"></settings>
  </header>
</template>

<script>
import logo from '../assets/logo.svg';
import switchIcon from '../assets/switch.svg';

import cogIcon from '../assets/cog.svg';
import addonIcon from '../assets/addon.svg';
import updateIcon from '../assets/update.svg';
import bellIcon from '../assets/bell.svg';
export default {
  name: 'Topbar',
  components: {
    logo,
    cogIcon,
    addonIcon,
    updateIcon,
    bellIcon,
    switchIcon
  },
  props: ['isLoading'],
  mounted() {
    window.eventHub.$on('updateAvailable', event => {
      this.$store.dispatch('SET_PANEL_UPDATE_INFO', event.update);
    });
  },
  data() {
    return {
      isUpdating: false,
      serverURL: window.serverURL,
      buttonLoaders: {
        checkUpdate: false
      },
      topMenu: [
        {
          name: 'Updates',
          href: '#updates',
          count: 1
        },
        {
          name: 'Notification',
          href: '#notification',
          count: 1
        },
        {
          name: 'Addons',
          href: '#addons',
          count: 1
        },
        {
          name: 'Settings',
          href: '#settings',
          count: 0
        }
      ]
    };
  },
  computed: {
    updateInfo() {
      let updateInfo = this.$store.getters.getPanelUpdateInfo;
      return updateInfo;
    },
    appInfo() {
      return this.$store.getters.getAppInfo;
    }
  },
  methods: {
    showSettings() {
      this.$refs.settingsmodal.$refs.settingsmodal.show();
    },
    resetDefaults() {
      this.isUpdating = false;
    },
    gotoHome() {
      this.$router.push({ name: 'Home' });
    },
    updateNow() {
      this.isUpdating = true;
    },
    checkUpdate() {
      this.buttonLoaders.checkUpdate = true;
      let payload = {
        requiredData: {
          forceCheckUpdateV3: 1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        let update = response.data.forceCheckUpdateV3;
        this.$store.commit('SET_PANEL_UPDATE_INFO', update);
        this.buttonLoaders.checkUpdate = false;
      });
    }
  }
};
</script>

<style scoped>
a:not([href]):not([tabindex]) {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Topbar.vue